module.exports = __webpack_public_path__ + "img/icon-table-popup.dd84bf5a.svg";